<!--业主管理详情-->
<template>
	<div class="pwnerManagerViewBody"
		v-loading="loading"
		:element-loading-text="loadingTitle"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<datePicker ref="datePicker" :initDate='nowSelectDate' type="day" @selectDate="selectDate"></datePicker>

		<!-- 分摊 -->
		<datePicker ref="datePickerBegin" :initDate='beginDate' @selectDate="beginDate = $event" type="day" style="z-index:10000;"></datePicker>
		<datePicker ref="datePickerEnd" :initDate='endDate' @selectDate="endDate = $event" type="day" style="z-index:10000;"></datePicker>

		<!--导出弹窗-->
		<billExportDialog ref='billExportDialog' :deviceList='bindDevice'
						  @startDate='$refs.bllStartDatePicker.show()' @endDate='$refs.bllEndDatePicker.show()'
						  :billStratSelectTime='billStratSelectTime' :billEndSelectTime='billEndSelectTime'>
		</billExportDialog>
		<!--选择导出账单的开始时间-->
		<datePicker ref="bllStartDatePicker" :initDate='billStratSelectTime' type="day" @selectDate="startSelectDate"></datePicker>
		<!--选择导出账单的结束时间-->
		<datePicker ref="bllEndDatePicker" :initDate='billEndSelectTime' type="day" @selectDate="endSelectDate"></datePicker>

		<div class="pwnerViewTop">
			<div class="topLeft">
				<el-button @click="backList()" size="small" type="primary">返回列表</el-button>
				<div class="topLeftDivNone">
					<div class="topLeftTitle">
						<h1>业主信息</h1></div>
					<button @click="$refs.billExportDialog.open()">账单导出</button>
				</div>
				<div class="topLeftDivTwo">
					<meterOwerDiv name='用户编号' :value='nowOwnerInformation.rfid' iconColor='rgb(64, 158, 255)'></meterOwerDiv>
					<meterOwerDiv name='用户姓名' :value='nowOwnerInformation.username' iconColor='rgb(102, 204, 204)'></meterOwerDiv>
					<meterOwerDiv name='缴费状态' value='已缴费' iconColor='rgb(179, 216, 255)'></meterOwerDiv>
					<meterOwerDiv name='用户余额' :value='balance(nowOwnerInformation.balance)' :keyName="'balance'" @chargeMoney="chargeMoney" iconColor='rgb(255, 153, 0)'></meterOwerDiv>
					<meterOwerDiv name='告警值' :value="nowOwnerInformation.balanceAlarm + '元'" iconColor='rgb(204, 204, 204)'></meterOwerDiv>
					<meterOwerDiv name='开户银行' :value='bankType(nowOwnerInformation.cardType)' iconColor='rgb(0, 204, 102)'></meterOwerDiv>
					<meterOwerDiv name='银行卡号' :value='nowOwnerInformation.cardNumber' iconColor='rgb(0, 153, 204)'></meterOwerDiv>
					<meterOwerDiv name='地址' :value='nowOwnerInformation.address' iconColor='rgb(236, 104, 104)'></meterOwerDiv>
				</div>
			</div>
			<div class="topMiddle">
				<div style="width: 100%;height: 10%;">
					<h1>关联设备</h1>
				</div>
				<div style="width: 100%;height: 90%;display: flex;flex-wrap: wrap;">
					<div class="deviceModule" v-for="item in bindDevice">
						<img v-show="item.deviceState == 1" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/deviceZaixian.png')" />
						<img v-show="item.deviceState != 1" :src="$store.resourcesStore.getters.getResourcesByName('/meterReading/overview/deviceLixian.png')" />

						<p>关联设备：{{item.deviceName}}</p>
						<p>表类型：{{item.meterRunType==1?"预付费电表":"普通表"}}</p>
						<p>扣费方式：{{item.billingMode=="StepBilling"?"阶梯式计费":item.billingMode=="PeakAndValleyBilling"?"费率计费":"单价计费"}}</p>
						<button>{{item.state232 == 1 ? '开启' : '关闭'}}</button>
					</div>
				</div>
			</div>
			<div class="topRigth">
				<div class="topRigthTop">
					<h1>运行预警</h1>
					<div class="flexCenter" v-show="eventData.total==0" style="margin-top: 25%;">
						<p class="notAvailableMessage">暂无预警信息</p>
					</div>
					<div class="warningModule" v-for="item in eventData.data"  v-show="eventData.total!=0">
						<span>{{item.typeName}}</span>
						<span>{{new Date(item.time).format('yyyy/MM/dd hh:mm')}}{{item.description}}</span>
					</div>
				</div>
				<div class="topRigthBottom">
					<h1>缴费信息</h1>
					<div class="flexCenter" v-show="payData.total==0" style="margin-top: 25%;">
						<p class="notAvailableMessage">暂无缴费信息</p>
					</div>
					<div class="warningModule" v-for="item in payData.data">
						<span>2019/11/29 10:52</span>
						<span>通过支付宝缴纳电费265元</span>
					</div>
				</div>
			</div>
		</div>
		<div class="pwnerViewBottom" style="display:flex;">
			<div style="height:100%; width:50%;">
				<p class="areaTitle">用电信息 单位:(KWH)
				<div class="changeTypeAndTime">
					<span class="selectDate" @click="$refs.datePicker.show()">{{nowSelectDate.formatByDate()}}<img :src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
					<div class="changeDateTypeBtns">
						<button v-for="item in timeTypeList" :class="{'nowDateTypeAct':nowTimeType == item.value}" @click="changeTimeType(item)">{{item.name}}</button>
					</div>
				</div>
				</p>
				<vchart ref='vchartBar' class="areaContentHeight"></vchart>
			</div>
			<div style="height:100%; width:50%;">
				<p class="areaTitle">分摊电费
				<div class="changeTypeAndTime">
						<span>
							<el-select v-model="divideType" placeholder="请选择">
								<el-option v-for="item in [{value:1,lable:'空调'},{value:2,lable:'公共(内部)'},{value:3,lable:'公共(外部)'}]" :key="item.value" :label="item.lable" :value="item.value">
								</el-option>
							</el-select>
						</span>
					<el-divider direction="vertical"></el-divider>
					<span class="selectDate" @click="$refs.datePickerBegin.show()">{{beginDate.formatByDate()}}<img :src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
					<span class="selectDate" @click="$refs.datePickerEnd.show()">{{endDate.formatByDate()}}<img :src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
				</div>
				</p>
				<vchart ref='vchartBarFentan' class="areaContentHeight"></vchart>
			</div>
		</div>
		<CashPayRechargeDialog ref="cashPayRechargeDialog"></CashPayRechargeDialog>
	</div>
</template>

<script>
	import meterOwerDiv from '@/components/module/customMade/meterOwerDiv.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import ownerManagerStore from './ownerManagerStore.js'
	import billExportDialog from '@/components/module/customMade/billExportDialog.vue'
	import CashPayRechargeDialog from './dialogs/CashPayRechargeDialog.vue'
	export default {
		components: {
			meterOwerDiv,
			vchart,
			datePicker,
			billExportDialog,
			CashPayRechargeDialog,
		},
		props: {},
		data() {
			return {
				options: {
					color: ['#3AA1FF'],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: []
					},
					grid: {
						top: 20,
						left: 15,
						right: 15,
						bottom: 10,
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisTick: {
							alignWithLabel: true
						},
						splitLine: {
							show: false
						}
					}],
					yAxis: {
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#CCCCCC'
							}
						},
						type: 'value'
					},
					series: []
				},
				optionsFentan: {
					color: ['#3AA1FF'],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: []
					},
					grid: {
						top: 20,
						left: 15,
						right: 15,
						bottom: 10,
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisTick: {
							alignWithLabel: true
						},
						splitLine: {
							show: false
						}
					}],
					yAxis: {
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#CCCCCC'
							}
						},
						type: 'value'
					},
					series: []
				},
				timeTypeList: [{
					name: '日电量',
					value: 'day'
				}, {
					name: '周电量',
					value: 'week'
				}, {
					name: '月电量',
					value: 'month'
				}, {
					name: '季电量',
					value: 'quarter'
				}, {
					name: '年电量',
					value: 'year'
				}],
				nowTimeType: 'month',
				bankList: [{
					text: '中国建设银行',
					value: 'CCB'
				}, {
					text: '中国农业银行',
					value: 'ABC'
				}, {
					text: '中国工商银行',
					value: 'ICBC'
				}, {
					text: '中国银行',
					value: 'BOC'
				}, {
					text: '中国民生银行',
					value: 'CMBC'
				}, {
					text: '招商银行',
					value: 'CMB'
				}, {
					text: '兴业银行',
					value: 'CIB'
				}, {
					text: '交通银行',
					value: 'BCM'
				}],
				energyUsed: 0,
				bindDevice: '',
				userDeviceInfo:[],
				dataObject: {},
				dataObjectFentan: {},//分摊图表数据
				fromName: {},
				eventData:{data:[],total:0},//事件
				payData:{data:[],total:0},//缴费信息
				billStratSelectTime:new Date(),
				billEndSelectTime:new Date(),
				divideType: 1,
				beginDate: new Date(new Date().formatByDate()),//分摊
				endDate: new Date(new Date().formatByDate()),
				loading: false,
				loadingTitle: '加载中',
			}
		},
		created() {
			debugPage=this
		},
		mounted() {
			this.deviceBanDing()
			this.$refs.vchartBar.setData(this.options, true)
			this.getVchartDatasFentan();
			this.getUserDeviceList();
		},
		destroyed() {},
		computed: {
			nowSelectDate() {
				return this.$store.cacheStore.getters.getNowSelectDate
			},
			resourcesStore() {
				return this.$store.resourcesStore.getters
			},
			nowOwnerInformation() {
				return ownerManagerStore.state.nowOwnerInformation
			},
			variableTree() {
				return deviceNo => {
					return this.$store.variableStore.getters.getVariableTree(deviceNo)
				}
			},
			variableNames() {
				// 所有的通讯变量名称
				var list = []
				let variableTreeList = []
				this.bindDevice.forEach(item => {
					this.variableTree(item.deviceNo).forEach(item2 => {
						variableTreeList.push(item2)
					})
				})
				for(var i = 0, len = variableTreeList.length; i < len; i++) {
					if(variableTreeList[i].no == 3) {
						var next = variableTreeList[i].next
						for(var i2 = 0, len2 = next.length; i2 < len2; i2++) {
							var item = next[i2]
							this.fromName[item.fromName] = item.name
							list.push(item.fromName)
						}
					}
				}
				return list
			},
		},
		watch: {
			dataObject(nv, ov) {
				this.reloadChart(nv)
			},
			bindDevice(nv, ov) {
				this.getVchartDatas(this.variableNames)
			},
			beginDate(nv, ov) {
				this.$refs.datePickerBegin.hide();
				this.getVchartDatasFentan();
			},
			endDate(nv, ov) {
				this.$refs.datePickerEnd.hide();
				this.getVchartDatasFentan();
			},
			divideType(nv, ov){
				this.getVchartDatasFentan();
			}
		},
		methods: {
			backList(){
				this.$router.push('/ownerManager')
			},
			startSelectDate(data){
				this.billStratSelectTime=data
				this.$refs.bllStartDatePicker.hide()
			},
			endSelectDate(data){
				this.billEndSelectTime=data
				this.$refs.bllEndDatePicker.hide()
			},
			balance(mone) {
				return mone / 100 + '元'
			},

			//业主设备列表
			getUserDeviceList() {
				this.$api.meterReadingApi.getUserDeviceList(this.nowOwnerInformation.id, respon => {
					this.userDeviceInfo = respon;
				})
			},

			//用户 余额
			getUserBalance(){
				this.$api.balanceApi.searchBalance(this.nowOwnerInformation.userId,"MeterReading",respon=>{
					debugger
					this.nowOwnerInformation.balance = respon.balance;
				})
			},

			// 业主账户充值
			chargeMoney() {
				this.$refs.cashPayRechargeDialog.open(this.userDeviceInfo,this.nowOwnerInformation.balance, (password, chargeNum,deviceNo,conversionRate) => {
					this.startLoad('正在充值')
					this.$api.payApi.cashPayRecharge(this.nowOwnerInformation.userId, 'MeterReading', chargeNum*100, password,deviceNo,conversionRate, respon => {
						this.stopLoad();
						this.$dialogMethod.showMessage(respon.toString())
						this.getUserBalance()
					}, err => {
						this.$dialogMethod.showMessage(err)
					})
				})
			},
			alertInfo() {
				//传用户id
				this.$api.recordApi.searchRecordLimit(this.nowOwnerInformation.id, 'MeterReading', 1, 100, undefined, undefined, undefined, respon => {
					this.payData=respon
				})
				//获取设备告警信息
				var today = new Date()
				var year = today.getFullYear()
				var month = today.getMonth()
				var todayTime = today.getTime()
				this.$api.eventApi.searchEventListByUser('', '', '', -1, '', -7, new Date(year, month, 1).getTime(),
						todayTime, 1, 4, '',
						respon => {
							this.eventData=respon
						})
			},
			selectDate(date) {
				this.$store.cacheStore.commit("setNowSelectDate", date)
				this.$refs.datePicker.hide()
				this.getVchartDatas(this.variableNames)
			},
			changeTimeType(item) {
				this.nowTimeType = item.value
				// 数据展示类型切换重新获取数据
				this.getVchartDatas(this.variableNames)
			},
			bankType(type) {
				var bankName = ''
				this.bankList.forEach(item => {
					if(item.value == type) {
						bankName = item.text
					}
				})
				return bankName
			},
			deviceBanDing() {
				//查询业主绑定的设备
				this.$api.meterReadingApi.getDeviceListByOwner(this.nowOwnerInformation.id, respon => {
					this.bindDevice = respon
					let deviceNos = ''
					this.bindDevice.forEach((item, index) => {
						if(index + 1 < this.bindDevice.length) {
							deviceNos += item.deviceNo + ','
						} else {
							deviceNos += item.deviceNo
						}
					})
					this.alertInfo()
				})
			},
			getVchartDatas(variableNames) {
				if(isempty(variableNames)) {
					return
				}
				this.$api.historyApi.getHistoryDifferenceRanking(variableNames.join(','), this.nowTimeType, this.nowSelectDate.getTime(), '',
						respon => {
							this.dataObject = respon;
						})
			},
			getVchartDatasFentan() {
				this.$api.tcFentanApi.userDivideFeeChart(this.nowOwnerInformation.id, this.divideType, this.beginDate.format('yyyy-MM-dd') + ' 00:00:00', this.endDate.format('yyyy-MM-dd') + ' 23:59:59', 'day',
						respon => {
							this.reloadChartFentan(respon);
						})
			},
			reloadChart(list) {
				if(isempty(list)) {
					return
				}
				switch(this.nowTimeType) {
					case 'day':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vlist = []
						//取整点值
						for(var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if(isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							var label = (i < 10 ? "0" : '') + i + ":00"
							vlist.push([label, item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vlist
						})
						break
					case 'week':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var weekList = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vList = []
						for(var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if(isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vList.push([weekList[i], item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vList
						})
						break
					case 'month':
						var keys = Object.keys(list)
						var seriesList = []
						var dataList = list[keys[0]]
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vlist = []
						for(var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if(isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vlist.push([(i + 1) + '日', item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vlist,
						})
						break
					case 'quarter':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var quarter = parseInt((this.nowSelectDate.getMonth() + 3) / 3)
						var Month = [
							["一月", "二月", "三月"],
							["四月", "五月", "六月"],
							["七月", "八月", "九月"],
							["十月", "十一月", "十二月"]
						]
						var quarterList = Month[quarter - 1]
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vList = []
						for(var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if(isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vList.push([quarterList[i], item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vList
						})
						break
					case 'year':
						var keys = Object.keys(list)
						var dataList = list[keys[0]]
						var seriesList = []
						var name = this.fromName[keys[0]] ? this.fromName[keys[0]] : keys[0]
						name = name.subByFirstChar(".")
						var vList = []
						for(var i = 0, len = dataList.length; i < len; i++) {
							var item = dataList[i]
							if(isNaN(parseFloat((item))) || isnull(parseFloat((item)))) {
								item = undefined
							}
							vList.push([(i + 1) + '月', item])
						}
						seriesList.push({
							name: name,
							type: 'bar',
							data: vList
						})
						break
				}
				this.options.series = seriesList
				this.$refs.vchartBar.setData(this.options, true)
			},
			reloadChartFentan(list) {
				for(var i=0; i<list.length; i++){
					var item = list[i];
					var fee = item[0];
					item[0] = new Date(item[1]).formatByDate();
					item[1] = fee;
				}
				var seriesList = [{
					name: '分摊电费',
					type: 'bar',
					data: list,
				}]
				this.optionsFentan.series = seriesList
				this.$refs.vchartBarFentan.setData(this.optionsFentan, true)
			},
			startLoad(title){
				this.loadingTitle = title;
				this.loading = true;
			},
			stopLoad(){
				this.loading = false;
			}
		}
	}
</script>

<style scoped>
	.pwnerManagerViewBody {
		width: 100%;
		height: 100%;
	}

	.pwnerViewTop {
		width: 100%;
		height: 70%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.pwnerViewTop .topLeft {
		width: 45%;
		height: 95%;
		border: solid rgb(210, 206, 206) .01rem;
	}

	.pwnerViewTop .topLeft .topLeftDivNone {
		width: 95%;
		height: 20%;
		margin: auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.topLeftDivNone .topLeftTitle {
		width: 25%;
		height: 30%;
	}

	.topLeftDivNone .topLeftTitle h1 {
		font-size: .16rem;
		padding-left: 10%;
	}

	.topLeftDivNone .framDiv {
		width: 20%;
		height: 80%;
		border: solid rgb(210, 206, 206) .01rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		border-radius: .1rem .1rem;
	}

	.topLeftDivNone .framDiv span {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: .1rem .1rem 0 0;
	}

	.topLeftDivNone .framDiv span:nth-child(1) {
		height: 40%;
		background-color: rgba(64, 158, 255, 1);
		color: white;
	}

	.topLeftDivNone .framDiv span:nth-child(2) {
		height: 60%;
	}

	.topLeftDivNone button {
		background-color: rgba(64, 158, 255, 1);
		color: white;
		width: 15%;
		height: 80%;
		border-radius: .1rem;
	}

	.pwnerViewTop .topLeft .topLeftDivTwo {
		width: 95%;
		height: 78%;
		margin: auto;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-around;
	}

	.topLeftDivTwo .meterOwerDivBody {
		width: 23%;
		height: 45%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.pwnerViewTop .topMiddle {
		width: 25%;
		height: 95%;
		border: solid rgb(210, 206, 206) .01rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		overflow-y: overlay;
	}

	.pwnerViewTop .topMiddle h1 {
		font-size: .2rem;
		padding-top: .2rem;
		padding-left: .2rem;
	}

	.pwnerViewTop .topMiddle .deviceModule {
		width: 45%;
		height: 30%;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.topMiddle .deviceModule button {
		color: #409EFF;
		border: .01rem solid rgba(179, 216, 255, 1);
		background-color: rgba(236, 245, 255, 1);
		padding: .1rem .2rem;
		border-radius: .1rem;
	}

	.pwnerViewTop .topRigth {
		width: 25%;
		height: 95%;
	}

	.pwnerViewTop .topRigth .topRigthTop {
		width: 100%;
		height: 48%;
		border: solid rgb(210, 206, 206) .01rem;
	}

	.pwnerViewTop .topRigth .topRigthBottom {
		width: 100%;
		height: 48%;
		border: solid rgb(210, 206, 206) .01rem;
		margin-top: 4%;
	}

	.pwnerViewTop .topRigth h1 {
		font-size: .15rem;
		padding-top: .2rem;
		padding-left: .2rem;
	}

	.pwnerViewTop .topRigth .warningModule {
		width: 80%;
		height: 15%;
		border: solid rgb(210, 206, 206) .01rem;
		margin-top: .1rem;
		margin-left: .2rem;
		display: flex;
		align-items: center;
	}

	.pwnerViewTop .topRigth .warningModule span:nth-child(1) {
		color: #FF9900;
		border: solid .01rem #FF9900;
		margin-left: .1rem;
		padding: .02rem .1rem;
		border-radius: .04rem;
	}

	.pwnerViewTop .topRigth .warningModule span:nth-child(2) {
		padding-left: .1rem;
	}
	/*底部*/

	.pwnerViewBottom {
		width: calc(100% - 0.2rem);
		height: 28%;
		border: solid rgb(210, 206, 206) .01rem;
		margin-top: .05%;
		margin-left: .1rem;
	}

	.pwnerViewBottom .areaTitle {
		font-size: .16rem;
		font-weight: bold;
		line-height: 48px;
		padding-left: .1rem;
	}

	.changeTypeAndTime {
		float: right;
		margin-top: -40px;
		padding-right: .1rem;
	}

	.selectDate {
		display: inline-block;
		margin-right: 20px;
		border: solid 1px #E4E4E4;
		border-radius: 4px;
		line-height: 34px;
		vertical-align: top;
		width: 120px;
		padding: 0 10px;
		font-weight: bold;
		color: #C0C4CC;
	}

	.selectDate>img {
		float: right;
		width: 17px;
		height: 19px;
		margin: 7px 0;
	}

	.changeDateTypeBtns {
		display: inline-block;
		border: solid 1px #409EFF;
		border-radius: 4px;
		overflow: hidden;
	}

	.changeDateTypeBtns>button {
		background: #ECF5FF;
		color: #409EFF;
		height: 32px;
		padding: 0 8px;
		cursor: pointer;
		border-right: solid 1px #409EFF;
		outline: none;
	}

	.changeDateTypeBtns>button:last-child {
		border: none;
	}

	.changeDateTypeBtns>.nowDateTypeAct {
		background: #409EFF;
		color: #FFFFFF;
	}

	.areaContentHeight {
		height: calc(100% - 48px)!important;
	}
	.noInfo{

	}
	.notAvailableMessage{
		border: solid 1px #E4E4E4;
		padding: 4px 50px;
		color: #CACACA;
	}
</style>